// Libraries.
import { electricPurple000, spanishViridian000 } from '@habitech/shared';
import styled from 'styled-components';

export const PlecaGreen = styled.div`
    background-image: url('/images/background.webp');
    background-size: cover;
    color: ${spanishViridian000};
    padding: 32px 0;
    .wrapperInfo {
        transition: all 0.8s ease-in-out;
        h1 {
            margin: 0 0 16px;
            font-style: normal;
            font-weight: 600;
            font-size: 24px;
            line-height: 32px;
        }
        p {
            margin: 0;
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
        }
    }
    &&.desactivate {
        height: 0px;
        padding: 0;
        pointer-events: none;
        .wrapperInfo {
            left: 200px;
            opacity: 0;
        }
    }
    @media ${({ theme }) => theme.screenSizes.tablet} {
        &&.desactivate {
            height: 0px;
            padding: 0;
            pointer-events: none;
            .wrapperInfo {
                left: 200px;
                opacity: 0;
            }
        }
        .wrapperInfo {
            h1 {
                font-size: 32px;
            }
            p {
                font-size: 16px;
            }
        }
    }
    @media ${({ theme }) => theme.screenSizes.laptop} {
        padding: 32px 0 0 0;
        height: 160px;
        margin-bottom: -96px;
        transition: all 1s ease-in-out;
        &&.desactivate {
            height: 160px;
            pointer-events: none;
            .wrapperInfo {
                left: 200px;
                opacity: 0;
            }
        }
        .wrapperInfo {
            padding: 0;
            width: 100%;
            max-width: 1328px;
            margin: 0px auto;
        }
    }
`;

export const WrapperPublicar = styled.div`
    width: 100%;
    background: ${electricPurple000};
    border-radius: 10px;
    padding: 0;
    .wrapperSteperDesktop {
        display: none;
    }

    .wrapperSteperFinalStep {
        padding: 32px 16px;
    }
    @media ${({ theme }) => theme.screenSizes.tablet} {
        padding: 24px 0px;
        .wrapperSteperFinalStep {
            padding: 0px;
            gap: 40px;
        }
    }
    @media ${({ theme }) => theme.screenSizes.laptop} {
        margin: 0 auto;
        padding: 48px 0;
        .wrapperSteperDesktop {
            display: block;
        }
        .wrapperSteperFinalStep {
            padding: 0px;
            gap: 40px;
        }
    }
`;
